export default "__VITE_PUBLIC_ASSET__e16a70df__"